import { Star } from "lucide-react";

export function StarRow({ value, size = "h-4 w-4", onPick, tid = "star" }) {
  return (
    <span className="inline-flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => {
        const cls = `${size} ${n <= Math.round(value) ? "fill-[#FFB800] text-[#FFB800]" : "text-slate-600"}`;
        return onPick
          ? <button key={n} type="button" data-testid={`${tid}-${n}`} aria-label={`${n} stars`} onClick={() => onPick(n)} className="transition-transform hover:scale-110"><Star className={cls} /></button>
          : <Star key={n} className={cls} />;
      })}
    </span>
  );
}
